/**
 * Scroll/fokus för kontaktsidan när URL har #kontor eller #medarbetare
 * (länkar från bot-vyn m.m.).
 */

function focusOfficesSelect(attempt) {
    const select = document.getElementById("offices-contact");
    if (!select) {
        return;
    }

    const filter =
        select.closest(".contact-offices__filter") || select.parentElement;
    const trigger = filter
        ? filter.querySelector(".formelements_select_display")
        : null;

    if (trigger) {
        if (!trigger.hasAttribute("tabindex")) {
            trigger.setAttribute("tabindex", "-1");
        }
        trigger.focus({ preventScroll: true });
        return;
    }

    if (attempt < 10) {
        window.setTimeout(() => focusOfficesSelect(attempt + 1), 50);
        return;
    }

    select.focus({ preventScroll: true });
}

function applyContactPageHash(isHashChange) {
    const raw = (window.location.hash || "").replace(/^#/, "");
    if (raw !== "kontor" && raw !== "medarbetare") {
        return;
    }

    const section = document.getElementById(raw);
    if (!section) {
        return;
    }

    const behavior = isHashChange ? "smooth" : "auto";

    const run = () => {
        section.scrollIntoView({ behavior, block: "start" });

        if (raw === "kontor") {
            focusOfficesSelect(0);
        } else {
            const search = document.getElementById("coworkers-contact-search");
            if (search) {
                search.focus({ preventScroll: true });
            }
        }
    };

    window.setTimeout(run, isHashChange ? 0 : 200);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
        applyContactPageHash(false),
    );
} else {
    applyContactPageHash(false);
}

window.addEventListener("hashchange", () => applyContactPageHash(true));
